import { useAuth0 } from '@auth0/auth0-react'
import type { FC } from 'react'

import ExitToAppIcon from '@mui/icons-material/ExitToApp'
import Avatar from '@mui/material/Avatar'
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import CardHeader from '@mui/material/CardHeader'
import FormControl from '@mui/material/FormControl'
import IconButton from '@mui/material/IconButton'
import TextField from '@mui/material/TextField'
import Tooltip from '@mui/material/Tooltip'

import { useAuthenticatedUser } from '../../auth/hooks/useAuthenticatedUser'
import { getAuth0Options } from '../../gateways/auth0'

import { ProfileBeheer } from './ProfileBeheer'

export interface Props {
  onChangeUserParam: (userParam: string) => void
  userParam: string
}

const BEHEER_DEELNEMERS = /** @type {string[]} */ ['DSP', 'Mijn Aansluiting']

export const Profile: FC<Props> = ({ onChangeUserParam, userParam }) => {
  const { user, logout } = useAuth0()
  const { returnTo } = getAuth0Options()

  const { combi, deelnemer, delegerende, switchUserParam } =
    useAuthenticatedUser()
  const isBeheer =
    switchUserParam &&
    !!deelnemer &&
    BEHEER_DEELNEMERS.includes(deelnemer) &&
    !combi

  return (
    <Card sx={{ width: 350 }}>
      <CardHeader
        avatar={<Avatar aria-label="avatar" src={user?.picture || ''}></Avatar>}
        title={combi ? 'Combi' : 'Deelnemer: '}
        subheader={combi ? combi : deelnemer}
      />
      <CardContent>
        {delegerende && (
          <FormControl sx={{ width: '100%', pb: 1 }}>
            <TextField
              variant="standard"
              fullWidth
              label="Gedelegeerd door"
              value={delegerende}
              slotProps={{
                input: { readOnly: true },
              }}
            />
          </FormControl>
        )}
        <FormControl sx={{ width: '100%', pb: 1 }}>
          <TextField
            variant="standard"
            fullWidth
            label="Email"
            value={user?.name || ''}
            slotProps={{
              input: { readOnly: true },
            }}
          />
        </FormControl>
        {isBeheer && (
          <FormControl sx={{ width: '100%', pb: 1 }}>
            <ProfileBeheer
              onChangeUserParam={onChangeUserParam}
              userParam={userParam}
            />
          </FormControl>
        )}
      </CardContent>
      <CardActions>
        <Tooltip title="Uitloggen">
          <IconButton
            onClick={() => logout({ logoutParams: { returnTo } })}
            sx={{ marginLeft: 'auto', color: 'black' }}
          >
            <ExitToAppIcon />
          </IconButton>
        </Tooltip>
      </CardActions>
    </Card>
  )
}
